export default __webpack_public_path__ + "static/media/Fuel.ea7c3919.svg";